const truncateText = (text, maxLength) => (!text ? '' : `${text.substring(0, maxLength)}...`)

export default truncateText
